import { Route, Routes } from "react-router-dom";
import AllPages from "../pages/AllPages";
import Home from "../pages/Home";
import SubmitLeadPage from "../pages/SubmitLeadPage";
import CatList from "../pages/CatPage";

export default function Router() {
  return (
    <Routes>
      <Route path="all-pages" element={<AllPages />} />
      <Route path="/:code?" element={<Home />} />

      <Route
        path="submit-lead-pioejkanjbxsauhehqaoijjjsajjashajshoiwjjlkaj"
        element={<SubmitLeadPage />}
      />
      <Route
        path="Add-category-jjakjsknjdshuhdjejmjajdjslaksjjdsijidjwijsk"
        element={<CatList />}
      />
    </Routes>
  );
}
